import React from 'react';
import {Box} from '@customink/pigment-react';
import {VisualSubcategoryLink} from './VisualSubcategoryLink';
import visualFilterMapping from 'constants/visualFilterMapping';

const VisualFilters = (props) => {
  const {subcategoryNavigation, categoryName} = props;
  const imagePath =
    process.env.NODE_ENV === 'development' ? '/products' : 'https://';

  return (
    <Box sx={{display: 'flex', overflow: 'scroll'}}>
      {subcategoryNavigation?.sibling_categories?.map((category) => {
        const {name, path} = category;
        if (name && path) {
          const visualFilterProperties = visualFilterMapping[name];
          if (
            visualFilterProperties?.title &&
            visualFilterProperties?.imageUrl
          ) {
            const {title, imageUrl} = visualFilterProperties;
            return (
              <VisualSubcategoryLink
                key={name}
                imageUrl={`${imagePath}/${imageUrl}`}
                title={title}
                linkUrl={path}
                isActive={name === categoryName}
              />
            );
          }
          return null;
        }
        return null;
      })}
    </Box>
  );
};

export default VisualFilters;
